import React, { FC, memo, useMemo } from 'react';
import LanguageSelect from 'Component/pages/components/LanguageSelect';
import { AsrFilterConfig } from 'src/api/types';
import { SecondaryTypeMap } from '../../const';
import { SelectProps } from 'antd';

interface TemplateProps {
    sourceType: number;
    value?: AsrFilterConfig;
    onChange?: (v: TemplateProps['value']) => void;
    disabledList?: number[];
    options?: SelectProps<number>['options'];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { sourceType, value, onChange, disabledList, options } = props;
    const mainLanguageType = disabledList?.[0];
    const selectedSecondaryList = useMemo(() => {
        const list = value?.filter?.multiLanguageTypeList || [];
        return list.filter((item) => item !== mainLanguageType);
    }, [mainLanguageType, value?.filter?.multiLanguageTypeList]);

    const disabledOptions = useMemo(() => {
        return options?.map((item) => {
            return {
                ...item,
                disabled: disabledList?.includes(item.value),
            };
        });
    }, [disabledList, options]);

    return (
        <LanguageSelect
            value={selectedSecondaryList}
            onChange={(v) => {
                const { ...restFilter } = value?.filter || {};
                onChange?.({
                    type: 1,
                    sourceType,
                    activeFlag: 1,
                    secondaryType: SecondaryTypeMap.LANG,
                    ...value,
                    filter: { ...restFilter, multiLanguageTypeList: v as number[] },
                });
            }}
            mode="multiple"
            maxTagCount={3}
            disabledList={disabledList}
            disabledAllListWithoutChecked={selectedSecondaryList.length >= 9}
            style={{ width: 300 }}
            options={disabledOptions}
        />
    );
});

export default Template;
